module.exports = __webpack_public_path__ + "img/home2.078d18e7.svg";